import React from 'react';
import { Typography, SvgIcon } from '@mui/material';
import { ReactComponent as ArrowIcon } from 'mui/assets/icons/DS_arrow-white.svg';
import Link from '../Link';
import { StyledButton, StyledButtonContent } from './DS_ButtonLinkStyles';

const ContentButton = ({ buttonVariant, buttonSize, buttonIcon, iconPlacement, title, icon }) => {
  let subTitle;
  let newTitle;
  if (title && title.match(/\((.*?)\)/)) {
    subTitle = title.substring(title.indexOf('('), title.indexOf(')') + 1);
    newTitle = title.split('(')[0];
  }

  return (
    <StyledButtonContent
      variant={buttonVariant}
      $isSizeBig={buttonSize}
      $buttonIcon={buttonIcon}
      isRight={iconPlacement}
    >
      <Typography variant="DS_copyMediumBold">
        {newTitle || title} {subTitle && <Typography variant="DS_copySmallRegular">{subTitle}</Typography>}
      </Typography>
      {buttonIcon !== 'No Icon' ? (
        <div>
          {' '}
          <SvgIcon component={icon ? icon : ArrowIcon} inheritViewBox={true} sx={{ fontSize: 24 }}></SvgIcon>
        </div>
      ) : null}
    </StyledButtonContent>
  );
};

const DS_ButtonLink = ({
  title,
  gtmEvent,
  gtmTrackingInfo,
  onClick,
  url,
  id,
  buttonVariant,
  buttonSize,
  buttonIcon,
  iconPlacement,
  disabled,
  noFollow,
  icon,
  target,
  type,
  external,
}) => {
  const _buttonVariant = buttonVariant ?? 'contained';
  const _buttonSize = buttonSize ?? true;
  const _buttonIcon = buttonIcon ?? 'No Icon';
  const _iconPlacement = iconPlacement ?? false;

  return url ? (
    <StyledButton
      component={Link}
      url={url}
      gtmEvent={gtmEvent}
      gtmTrackingInfo={gtmTrackingInfo}
      variant={_buttonVariant}
      $isSizeBig={_buttonSize}
      $buttonIcon={_buttonIcon}
      disabled={disabled}
      noFollow={noFollow}
      target={target}
      external={external}
    >
      <ContentButton
        buttonVariant={_buttonVariant}
        buttonSize={_buttonSize}
        buttonIcon={_buttonIcon}
        iconPlacement={_iconPlacement}
        title={title}
      />
    </StyledButton>
  ) : (
    <StyledButton
      onClick={onClick}
      id={id}
      type={type}
      aria-label="button"
      gtmEvent={gtmEvent}
      gtmTrackingInfo={gtmTrackingInfo}
      variant={_buttonVariant}
      $isSizeBig={_buttonSize}
      $buttonIcon={buttonIcon}
      disabled={disabled}
    >
      <ContentButton
        buttonVariant={_buttonVariant}
        buttonSize={_buttonSize}
        buttonIcon={_buttonIcon}
        iconPlacement={_iconPlacement}
        title={title}
        icon={icon}
      />
    </StyledButton>
  );
};

export default DS_ButtonLink;
